<div class="container-main">
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-8 form-group">
        <span class="text-footer">© Copyright 2021 Todos los derechos reservados</span>
      </div>
      <div class="col-12 col-sm-4 form-group">
        <div class="icon-footer">
          <a class="link-social" href="https://www.facebook.com/cursosAndroidAnt" target="_blank"><i class="fa fa-facebook-square" aria-hidden="true"></i></a>
          <a class="link-social" href="https://twitter.com/alain_nt" target="_blank"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
          <a class="link-social" href="https://www.youtube.com/channel/UC9Cxb3wO3GmsVn0j8KFS7Ww" target="_blank"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
          <a class="link-social" href="https://www.linkedin.com/in/alain-nicol%C3%A1s-tello-aa4a25bb/"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a>
        </div>
      </div>
    </div>
  </div>
</div>